import { Localization } from '../../../hooks/useLocalizations'
import { CreateLocalizationFormType, ProductLocalizedKeys } from './types'

export const getInitialValues = (
  product: ProductLocalizedKeys | null,
  localization?: Localization
) => {
  if (product === null) return {}

  return {
    id: localization?.id,
    country: localization?.country,
    subdivision: localization?.subdivision,
    name: localization?.name ?? product.name,
    description: localization?.description ?? product.description,
    category_label: localization?.category_label ?? product.kind_subtype,
    lineage: localization?.lineage ?? product.lineage,
    image_urls: localization?.images ?? product.image_urls,
  }
}

/**
 * Crates an object with the shape expected by Create Localization form. It will
 * return an object with blank initial values if given no localization or
 * product. If localization/product are provided it will look for a value in
 * localization first, then fall back to the product value and finally fall back
 * to the default empty value.
 */
export const getInitialCreateValues = (
  product: ProductLocalizedKeys,
  localization?: Localization
): CreateLocalizationFormType => {
  return {
    country: localization?.country ?? '',
    subdivision: localization?.subdivision ?? '',
    name: localization?.name ?? product?.name ?? '',
    description: localization?.description ?? product?.description ?? '',
    category_label: localization?.category_label ?? product?.kind_subtype ?? '',
    lineage: localization?.lineage ?? product?.lineage,
    image_urls: localization?.images ?? product?.image_urls ?? [],
    state_selector: '',
  }
}
